import { pickKeys } from 'lib/object/objectUtils'

export function slimifyGeo(geo: App.GeoState): Pick<App.GeoState, 'currentRegionCode' | 'currentCurrency'> {
  return pickKeys(['currentRegionCode', 'currentCurrency'], geo)
}

export function getPlaceKey(latitude?: number, longitude?: number, levels?: Array<App.PlaceType>): string {
  if (!latitude || !longitude) {
    return 'no-lat-long'
  }

  if (!levels) {
    return `${latitude}-${longitude}`
  }

  return `${latitude}-${longitude}-${levels?.join(',')}`
}
